
import request from "../utils/request";


export function cmsPresonList(data) {
    return request({
        url: "/person/cmsPresonList",
        data: data,
    });
}

export function cmsPresonEdit(data) {
    return request({
        url: "/person/cmsPresonEdit",
        data: data,
    });
}

export function cmsPresonAdd(data) {
    return request({
        url: "/person/cmsPresonAdd",
        data: data,
    });
}